import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Flex, Spinner, Text } from '@radix-ui/themes';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DateFieldComponent from '../../components/inputs/Datefield/DatefieldComponent';
import { DragAndDropFileUpload } from '../../components/inputs/FileUpload/DragAndDropFileUpload';
import TextAreaFieldComponent from '../../components/inputs/TextAreafield/TextAreafieldComponent';
import { useAppDispatch } from '../../hooks/hooks';
import { resetLessonPlanData } from '../../redux/slices/school/lessonPlan';
import { RootState } from '../../redux/store';
import { routes } from '../../routes';
import { createLessonPlanDocument } from '../../services/school/lessonPlans/createLessonPlan';
import { updateLessonPlan, updateLessonPlanDocument } from '../../services/school/lessonPlans/updateLessonPlan';
import { LessonPlanDocumentType, LessonPlanType } from '../../types/LessonPlan';
import { dataURLtoFile, getFile } from '../../utils/fileUtils';
import { CreateLessonPlanFormValidation } from '../Teachers/CreateLessonPlanFormValidation';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';

export const LessonPlanPreview = () => {
  const lessonPlanData = useSelector((state: RootState) => state.lessonPlan);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const documents = lessonPlanData.documents?.map((document: LessonPlanDocumentType) => {
    if (document.docBase64) {
      const file = dataURLtoFile(document.docBase64, document.filename);
      return { ...document, file, docBase64: "" };
    }
    return { ...document, docBase64: "" };
  });

  const defaultValues = { ...lessonPlanData, documents };
  const { control, handleSubmit, setValue, getValues, formState: { errors }, reset } = useForm<LessonPlanType>({
    resolver: yupResolver(CreateLessonPlanFormValidation),
    defaultValues,
    mode: 'onBlur',
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'documents',
  });

  const onSubmit = handleSubmit(async (data) => {
  });

  const handleClickBack = () => {
    navigate(routes.getClassLessonPlans);
    dispatch(resetLessonPlanData());
  };
  return (
    <Flex direction="column" gap="4">
      <form onSubmit={onSubmit} noValidate>
        <Flex direction="column" gap="4">
          <TextAreaFieldComponent name="objectives" label="Objectivos" control={control} errors={errors} fieldProps={{ disabled:"disabled" }} />
          <TextAreaFieldComponent name="activities" label="Atividades" control={control} errors={errors} fieldProps={{ disabled:"disabled" }} />
          <TextAreaFieldComponent name="resources" label="Recursos" control={control} errors={errors} fieldProps={{ disabled:"disabled" }} />
          <DateFieldComponent name="date" label="Data" control={control} errors={errors}  
          fieldProps={{ disabled:"disabled" }}
           />

          <Flex direction="column" gap="3">
            <Text as="label">Documentos</Text>
            {fields.map((f, index) => (
              <Box
               key={index}
               p="3"
               mb="3"
               style={{ border: '1px solid var(--gray-6)', borderRadius: 'var(--radius-3)', position: 'relative' }}
               >
                   <Controller
                        name={`documents.${index}.file` as const}
                        control={control}
                        render={({ field }) => (
                          <DragAndDropFileUpload
                            onFileDrop={(file) => {
                            }}
                            accept="*"
                            selectedFile={field.value}
                            isReadOnly={true}
                          />
                        )}
                      />
                    {errors.documents?.[index]?.file && (
                        <Text color="red" size="1" mt="1">
                          {`${errors.documents[index]?.file?.message}`}
                        </Text>
                      )}
              </Box>
            ))}
          </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                  <Button type="button" variant="soft" color="gray" onClick={handleClickBack}>
                    <ChevronLeftIcon /> Voltar
                  </Button>
               
                </Flex>

    
        </Flex>
      </form>
    </Flex>
  );
};
